import { render, staticRenderFns } from "./ProductPrices.vue?vue&type=template&id=258b90f4"
import script from "./ProductPrices.vue?vue&type=script&lang=js"
export * from "./ProductPrices.vue?vue&type=script&lang=js"
import style0 from "./ProductPrices.vue?vue&type=style&index=0&id=258b90f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports